module.exports = __webpack_public_path__ + "static/media/guideB2b.f406962d.md";